export default "__VITE_ASSET__CRznIxMB__"